import { render } from "./GetTextModal.vue?vue&type=template&id=18a679aa&scoped=true"
import script from "./GetTextModal.vue?vue&type=script&lang=js"
export * from "./GetTextModal.vue?vue&type=script&lang=js"

import "./GetTextModal.vue?vue&type=style&index=0&id=18a679aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a679aa"]])

export default __exports__